'use es6';

import http from 'conversations-http/clients/http';
export const fetchCvCrmObject = ({
  cvObjectId
}) => http.get(`crm-objects/v1/objects/conversation/${cvObjectId}?properties=hs_thread_id`);